export enum BaseGroupType {
    Employee = 0,
    Recording = 1,
    DataAttribute = 2,
    UserAttribute = 3,
    Filterables = 4,
}

export class GroupType {
    CompanyID: number;
    GroupTypeName: string;
    Assignable: boolean;
    BaseGroupType: BaseGroupType;
    GroupLevel: number;
}

export interface GroupViewBy {
    GroupType: BaseGroupType;
    GroupLevel: number;
}